export enum GridWidthCssVariable {
  Desktop = '--desktop-grid',
}
